export default __webpack_public_path__ + "static/creativity-quote-0c6156efe63e423867db0afd51387d58.svg";